// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Unauthorized_wrapper__NC88x","buttonsRow":"Unauthorized_buttonsRow__1QeM2"};